import { Form, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import './secciones.scss';
import { MONITOREOS_VISITAS_VERIFICACION } from 'constants/tipoMonitoreos';

const SeccionServidoresPub = ({ form, tipoMon }) => {
  return (
    <div>
      <Form form={form} layout="horizontal">
        <div className="container-datos">
          <Form.Item name="numEmpleadoSP">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ numEmpleadoSP: target.checked });
              }}>
              Número de empleado
            </Checkbox>
          </Form.Item>
          <Form.Item name="nombreSP">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ nombreSP: target.checked });
              }}>
              Nombre(s)
            </Checkbox>
          </Form.Item>
          <Form.Item name="primerApellidoSP">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ primerApellidoSP: target.checked });
              }}>
              Primer apellido
            </Checkbox>
          </Form.Item>
          <Form.Item name="segundoApellidoSP">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ segundoApellidoSP: target.checked });
              }}>
              Segundo apellido
            </Checkbox>
          </Form.Item>
          <Form.Item name="puestoSP">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ puestoSP: target.checked });
              }}>
              Puesto
            </Checkbox>
          </Form.Item>
          {tipoMon === MONITOREOS_VISITAS_VERIFICACION ? (
            <>
              <Form.Item name="claveElectorSP">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ claveElectorSP: target.checked });
                  }}>
                  Clave de elector
                </Checkbox>
              </Form.Item>
              <Form.Item name="dependenciaSP">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ dependenciaSP: target.checked });
                  }}>
                  Dependencia
                </Checkbox>
              </Form.Item>
              <Form.Item name="horarioSP">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ horarioSP: target.checked });
                  }}>
                  Horario
                </Checkbox>
              </Form.Item>
              <Form.Item name="nivelSP">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ nivelSP: target.checked });
                  }}>
                  Nivel de participación
                </Checkbox>
              </Form.Item>
              <Form.Item name="transporteSP">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ transporteSP: target.checked });
                  }}>
                  Transporte
                </Checkbox>
              </Form.Item>
            </>
          ) : (
            <>
              <Form.Item name="constanciaSP">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ constanciaSP: target.checked });
                  }}>
                  Número de constancia
                </Checkbox>
              </Form.Item>
              <Form.Item name="anversoSP">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ anversoSP: target.checked });
                  }}>
                  Identificación anverso
                </Checkbox>
              </Form.Item>
              <Form.Item name="reversoSP">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ reversoSP: target.checked });
                  }}>
                  Identificación reverso
                </Checkbox>
              </Form.Item>
            </>
          )}
          <Form.Item name="firmaSP">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ firmaSP: target.checked });
              }}>
              Firma
            </Checkbox>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default SeccionServidoresPub;

SeccionServidoresPub.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired,
  tipoMon: PropTypes.number.isRequired
};
